import { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { useAuthContext } from 'state/auth';
import { useMParticleContext } from 'state/mParticle';
import { useOffersContext } from 'state/offers';
import { routes } from 'utils/routing';
import { toast } from 'utils/toast';

const OfferActivatePage = () => {
  const { offerId, tokenId } = useParams();
  const [activationAttempted, setActivationAttempted] = useState(false);

  const { isAuthenticated: getIsAuthenticated } = useAuthContext();
  const { logOfferActivatedEvent } = useMParticleContext();
  const { activateOffer } = useOffersContext();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const isAuthenticated = getIsAuthenticated();

  const handleActivation = async () => {
    try {
      const { isOfferActivated } = await activateOffer(tokenId ?? '');

      if (isOfferActivated) {
        logOfferActivatedEvent(offerId ?? '', '', tokenId);
        toast.success(formatMessage({ id: 'offerActivationSuccess' }));
      } else {
        toast.error(formatMessage({ id: 'offerActivationError' }));
      }
    } catch (err) {
      toast.error(formatMessage({ id: 'offerActivationError' }));
    } finally {
      navigate(routes.base, { replace: true });
    }
  };

  useEffect(() => {
    if (isAuthenticated && !activationAttempted) {
      setActivationAttempted(true);
      handleActivation();
    }
    /* eslint-disable-next-line */
  }, [activationAttempted, isAuthenticated]);

  return null;
};

export default OfferActivatePage;
